import {
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { IntegrationService } from 'src/app/services/integration.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseResponse } from 'src/app/models/base-response.model';
// Layout

@Component({
  selector: 'kt-aside-left',
  templateUrl: './aside-left.component.html',
  styleUrls: ['./aside-left.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class AsideLeftComponent implements OnInit, AfterViewInit {

  //public coreMenus: any[] = [];
  public coreToken: string;
  public coreMenu$: Observable<BaseResponse<any>>;
  activeToggleIndex: any;

  constructor(
    public integrationService: IntegrationService
  ) {
  }

  ngOnInit() {
    this.coreToken = localStorage.getItem('coreToken');
    this.integrationService.coreMenu$.subscribe();
    this.coreMenu$=this.integrationService.coreMenu$;
  }
  togglemenu(v) {
    this.activeToggleIndex = (this.activeToggleIndex === v) ? null : v;
  }

  ngAfterViewInit(): void {
  }



}
